import React from "react";
import { Box, Chip, Tooltip } from "@mui/material";
import WorkspacePremiumRounded from "@mui/icons-material/WorkspacePremiumRounded";
import { useMessage } from "../i18n/locale";

export default function ProFeatureControl({
  locked,
  children,
  label,
  lockedMessage,
  showProBadge = true,
}) {
  const proRequired = useMessage("proAccountRequired");
  const tooltip = lockedMessage || proRequired;
  const content = (
    <Box
      component="span"
      aria-label={locked ? `${label}. ${tooltip}` : undefined}
      sx={{ display: "inline-flex", alignItems: "center", gap: 0.75, width: "fit-content" }}
    >
      {children}
      {locked && showProBadge && (
        <Chip
          icon={<WorkspacePremiumRounded />}
          label="Pro"
          color="secondary"
          size="small"
          sx={{ pointerEvents: "none" }}
        />
      )}
    </Box>
  );

  return locked ? <Tooltip title={tooltip} arrow>{content}</Tooltip> : content;
}
